// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TdfE","col":"styles_col__1vrRu"};